export default "Crowds, oil spills, and obstacles!";